import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE} from '../../../constants';
import {Karma} from '../../../helpers/Urls';

export const FETCH_DAVT_TASKS = 'FETCH_DAVT_TASKS';
export const FETCH_DAVT_TASKS_COMPLETED = 'FETCH_DAVT_TASKS_COMPLETED';
export const FETCH_DAVT_TASKS_FAILED = 'FETCH_DAVT_TASKS_FAILED';

export const SET_DATE_RANGE = 'SET_DATE_RANGE';

export const FETCH_TASK_DETAILS = 'FETCH_TASK_DETAILS';
export const FETCH_TASK_DETAILS_COMPLETED = 'FETCH_TASK_DETAILS_COMPLETED';
export const FETCH_TASK_DETAILS_FAILED = 'FETCH_TASK_DETAILS_FAILED';

export const SEND_TASK_FOR_APPROVAL = 'SEND_TASK_FOR_APPROVAL';
export const SEND_TASK_FOR_APPROVAL_COMPLETED =
  'SEND_TASK_FOR_APPROVAL_COMPLETED';
export const SEND_TASK_FOR_APPROVAL_FAILED = 'SEND_TASK_FOR_APPROVAL_FAILED';

export const SUBMIT_FS_QUESTIONNAIRE = 'SUBMIT_FS_QUESTIONNAIRE';
export const SUBMIT_FS_QUESTIONNAIRE_COMPLETED =
  'SUBMIT_FS_QUESTIONNAIRE_COMPLETED';
export const SUBMIT_FS_QUESTIONNAIRE_FAILED = 'SUBMIT_FS_QUESTIONNAIRE_FAILED';

export const TOGGLE_DAVT_USER_STATUS = 'TOGGLE_DAVT_USER_STATUS';
export const TOGGLE_DAVT_USER_STATUS_COMPLETED =
  'TOGGLE_DAVT_USER_STATUS_COMPLETED';
export const TOGGLE_DAVT_USER_STATUS_FAILED = 'TOGGLE_DAVT_USER_STATUS_FAILED';

export const RESET_PAGE = 'RESET_PAGE';

const INITIAL_STATE = {
  isFetchingTasks: false,
  isRequestingTaskDetails: false,
  sendingTaskForApproval: false,
  submittingQuestionnaire: false,
  hasError: false,
  error: '',
  selectedDateRange: null,
  selectedDateStrings: null,
};

export const fetchDavtTasks = (
  page,
  search,
  resetPage = true,
  taskName = '',
  dateRange = '',
) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_DAVT_TASKS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Karma.fetchDavtTasksURL(page, search, taskName, dateRange),
      });
      const {data, status} = response || {};
      if (resetPage) {
        dispatch({type: RESET_PAGE});
      }

      if (status === true) {
        dispatch({type: FETCH_DAVT_TASKS_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_DAVT_TASKS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_DAVT_TASKS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const setDateRange = (dates, dateStrings) => ({
  type: SET_DATE_RANGE,
  payload: {
    dates,
    dateStrings,
  },
});

export const fetchTaskDetails = (taskId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_TASK_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Karma.fetchTaskDetailsURL(taskId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_TASK_DETAILS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: FETCH_TASK_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_TASK_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const sendTaskForApproval = (actionType, requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SEND_TASK_FOR_APPROVAL});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Karma.sendTaskForApprovalURL(actionType),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: SEND_TASK_FOR_APPROVAL_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: SEND_TASK_FOR_APPROVAL_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SEND_TASK_FOR_APPROVAL_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const submitFSQuestionnaire = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SUBMIT_FS_QUESTIONNAIRE});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Karma.submitFSQuestionnaireURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: SUBMIT_FS_QUESTIONNAIRE_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: SUBMIT_FS_QUESTIONNAIRE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SUBMIT_FS_QUESTIONNAIRE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const toggleDavtUserStatus = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: TOGGLE_DAVT_USER_STATUS});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Karma.toggleDavtUserStatusURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: TOGGLE_DAVT_USER_STATUS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: TOGGLE_DAVT_USER_STATUS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: TOGGLE_DAVT_USER_STATUS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action || {};
  switch (type) {
    case FETCH_DAVT_TASKS:
      return {
        ...state,
        isFetchingTasks: true,
      };
    case FETCH_DAVT_TASKS_COMPLETED:
      return {
        ...state,
        isFetchingTasks: false,
        tasksData: payload,
        hasError: false,
      };
    case FETCH_DAVT_TASKS_FAILED:
      return {
        ...state,
        isFetchingTasks: false,
        hasError: true,
        error: payload.error,
      };
    case FETCH_TASK_DETAILS:
      return {
        ...state,
        isRequestingTaskDetails: true,
      };
    case FETCH_TASK_DETAILS_COMPLETED:
      return {
        ...state,
        hasError: false,
        isRequestingTaskDetails: false,
        taskDetailsData: payload,
      };
    case FETCH_TASK_DETAILS_FAILED:
      return {
        ...state,
        hasError: true,
        isRequestingTaskDetails: false,
      };
    case SEND_TASK_FOR_APPROVAL:
      return {
        ...state,
        sendingTaskForApproval: true,
      };
    case SEND_TASK_FOR_APPROVAL_COMPLETED:
      return {
        ...state,
        sendingTaskForApproval: false,
        tasksData: payload,
        hasError: false,
      };
    case SEND_TASK_FOR_APPROVAL_FAILED:
      return {
        ...state,
        sendingTaskForApproval: false,
        hasError: true,
        error: payload.error,
      };
    case SUBMIT_FS_QUESTIONNAIRE:
      return {
        ...state,
        submittingQuestionnaire: true,
      };
    case SUBMIT_FS_QUESTIONNAIRE_COMPLETED:
      const answers = payload.answers || {};
      return {
        ...state,
        submittingQuestionnaire: false,
        seal_stamp_clear: answers['7'],
        consignee_seal_match: answers['8'],
      };
    case SUBMIT_FS_QUESTIONNAIRE_FAILED:
      return {
        ...state,
        submittingQuestionnaire: false,
        hasError: true,
        error: payload.error,
      };
    case SET_DATE_RANGE:
      return {
        ...state,
        selectedDateRange: action.payload.dates,
        selectedDateStrings: action.payload.dateStrings,
      };
    default:
      return state;
  }
};
